import { useEffect } from "react";
import breadCrumbsStore from "../store/breadCrumbs";

export const useBreadcrumbs = (crumbs) => {
  const { setBreadcrumbs } = breadCrumbsStore;

  useEffect(() => {
    setBreadcrumbs(crumbs);
    return () => {
      setBreadcrumbs([]);
    }
  }, [crumbs]);

}